/**
 * Created by andrey on 08.08.2025
 */

cc.Hide = function () {
    cc.ActionInstant.prototype.constructor.call(this);
};

cc.Hide.prototype = Object.assign(Object.create(cc.ActionInstant.prototype), {
    constructor: cc.Hide,

    update: function () {
        this.target.visible = false;
    }
});

cc.hide = () => new cc.Hide();